module.exports = __webpack_public_path__ + "static/media/img2.73a20b48.jpg";